/**
 * API methods that require the tracking ID to be included in the URL path.
 * These endpoints use the pattern: /tracking-ids/{trackingId}/{method}
 * All other endpoints use: /{method}
 */
export const TRACKING_ID_IN_PATH_METHODS = [
    'badges',
];
